import React from 'react';
import { Box, Chip, IconButton, TextField, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';
import InfoIcon from '@mui/icons-material/Info';
import { ScribePanel, ScribePanelHeader } from '../../components/scribe/ScribeUI';
import { scribeTokens as ui } from '../../components/scribe/tokens';

export default function SophieAssistantPanel({ onClose, chatBoxRef, onScroll, messages, contextLabel, newMessage, setNewMessage, onSend }) {
  return <ScribePanel role="complementary" aria-label="Ask Sophie" sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
    <ScribePanelHeader title="Ask Sophie"
      actions={<IconButton size="small" aria-label="Close Ask Sophie" onClick={onClose}><CloseIcon fontSize="small" /></IconButton>}
      sx={{ flexShrink: 0, borderBottom: `1px solid ${ui.colors.border}` }} />
    <Box ref={chatBoxRef} onScroll={onScroll} sx={{ flex: 1, overflowY: 'auto', p: 1.5, display: 'flex', flexDirection: 'column', gap: 1.5, minHeight: 0 }}>
      {messages}
    </Box>
    <Box sx={{ px: 2, py: 1, flexShrink: 0, borderTop: `1px solid ${ui.colors.border}`, bgcolor: ui.colors.subtle }}>
      <Typography variant="caption" sx={{ fontWeight: 600, color: ui.colors.secondary, display: 'block', mb: .5 }}>Quick Actions</Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: .5 }}>
        {['Suggest improvements', 'Add treatment plan', 'Expand section', 'Check completeness'].map(action => (
          <Chip key={action} label={action} size="small" onClick={() => setNewMessage(action)}
            sx={{ bgcolor: ui.colors.accentSoft, color: ui.colors.accent, border: `1px solid ${ui.colors.accentBorder}`, '&:hover': { bgcolor: ui.colors.accentSoft } }} />
        ))}
      </Box>
    </Box>
    <Box sx={{ p: 2, flexShrink: 0, borderTop: `1px solid ${ui.colors.border}` }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: .5, mb: 1, px: 1, py: .5, borderRadius: `${ui.radius.control}px`, bgcolor: ui.colors.accentSoft }}>
        <InfoIcon sx={{ fontSize: 14, color: ui.colors.accent, flexShrink: 0 }} />
        <Typography variant="caption">{contextLabel}</Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-end' }}>
        <TextField value={newMessage} onChange={event => setNewMessage(event.target.value)}
          onKeyDown={event => { if (event.key === 'Enter' && !event.shiftKey) { event.preventDefault(); onSend(); } }}
          placeholder="Ask AI for help..." inputProps={{ 'aria-label': 'Message Sophie' }} fullWidth multiline maxRows={3} size="small"
          sx={{ '& .MuiOutlinedInput-root': { bgcolor: ui.colors.subtle, '&:hover fieldset': { borderColor: ui.colors.accent }, '&.Mui-focused fieldset': { borderColor: ui.colors.accent } } }} />
        <IconButton size="small" aria-label="Send message to Sophie" onClick={onSend} disabled={!newMessage.trim()}
          sx={{ bgcolor: ui.colors.accent, color: ui.colors.surface, '&:hover': { bgcolor: ui.colors.accentHover }, '&.Mui-disabled': { bgcolor: ui.colors.disabled, color: ui.colors.disabledText } }}>
          <SendIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  </ScribePanel>;
}
